import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import { Container } from "./Container";

const SUPPORT_EMAIL = "support@rareroles.com";

/**
 * Site footer. Content and links can be passed as children or via props for easy rebrand.
 */
export function Footer({ className, children, ...props }) {
  return (
    <footer
      className={cn(
        "border-t border-border/60 py-8 text-sm text-muted-foreground max-md:pb-[max(2rem,env(safe-area-inset-bottom))]",
        className
      )}
      data-testid="footer"
      {...props}
    >
      <Container>
        {children ?? (
          <div className="flex flex-col items-center gap-5 sm:items-stretch">
            <div className="flex w-full flex-col items-center gap-4 sm:flex-row sm:items-center sm:justify-between">
              <span className="text-center sm:text-left">
                &copy; {new Date().getFullYear()} RareRoles. All rights reserved.
              </span>
              <nav
                className="flex flex-wrap items-center justify-center gap-x-6 gap-y-1"
                aria-label="Legal"
                data-testid="footer-legal-nav"
              >
                <Link
                  to="/terms"
                  className="font-medium text-foreground/90 underline-offset-4 hover:text-primary hover:underline"
                  data-testid="footer-link-terms"
                >
                  Terms
                </Link>
                <Link
                  to="/privacy"
                  className="font-medium text-foreground/90 underline-offset-4 hover:text-primary hover:underline"
                  data-testid="footer-link-privacy"
                >
                  Privacy
                </Link>
              </nav>
            </div>
            <p className="border-t border-border/60 pt-5 text-center text-sm sm:text-left">
              <span className="text-muted-foreground">Support: </span>
              <a
                href={`mailto:${SUPPORT_EMAIL}`}
                className="font-medium text-primary underline-offset-4 hover:underline"
                data-testid="footer-support-email"
              >
                {SUPPORT_EMAIL}
              </a>
            </p>
          </div>
        )}
      </Container>
    </footer>
  );
}
